"use client"; // Error components must be Client Components

import SomethingWentWrong from "@components/table/SomethingWentWrong";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return (
    <body style={{ background: "white", height: "100vh" }}>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center", height: "100%" }}>
        <SomethingWentWrong
          message={`Something went wrong!`}
          heightCustom="500px"
          border={true}
          hardReload
          emptyDataRedirection={false}
        />
      </div>
    </body>
  );
}
